// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"36e0fac5","149":"c04821cd","164":"58641a7c","170":"9d6ea84d","278":"94b30e4c","372":"715232f3","624":"ca286ca0","730":"98fb29df","892":"80fa7bed","894":"70773f8e","935":"f1f20feb","946":"0c962afd"}[chunkId] + ".chunk.js";
};